module.exports = __webpack_public_path__ + "static/media/icon_mainmenu.a234e9c7.svg";